import React from "react";
import ReactDOM from "react-dom";

import log from 'loglevel';
import { LOG_LEVEL } from './components/common/consts';
import AppAuthContainer from "./components/app/AppAuthContainer";

var logging = log.noConflict();
log.setLevel(LOG_LEVEL.DEBUG);

const rootElement = document.getElementById("root");
ReactDOM.render(<AppAuthContainer/>, rootElement);



